// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.1.0",
  "buildDate": "2026-09-16T15:21:57.336Z"
};

export default buildInfo;
